try {
    window.$ = window.jQuery = require('jquery');
    require('bootstrap');  // Popper.js is now bundled with Bootstrap 5
} catch (e) {}

import { gsap } from "gsap";


require('./parts/header-menu.js');
require('./parts/home.js');
require('./parts/common.js');

